import './App.css';
import FirstScreenRec from './ReceptionistScreens/FirstScreenRec';
import SecondScreenRec from './ReceptionistScreens/SecondScreenRec';
import ThirdScreenRec from './ReceptionistScreens/ThirdScreenRec';
import FourthScreenRec from './ReceptionistScreens/FourthScreenRec';
import FifthScreenRec from './ReceptionistScreens/FifthScreenRec';
import SixthScreenRec from './ReceptionistScreens/SixthScreenRec';
import SeventhScreenRec from './ReceptionistScreens/SeventhScreenRec';
import EighthScreenRec from './ReceptionistScreens/EighthScreenRec';
import NinthScreenRec from './ReceptionistScreens/NinthScreenRec';
import TenthScreenRec from './ReceptionistScreens/TenthScreenRec';
import EleventhScreenRec from './ReceptionistScreens/EleventhScreenRec';
import ByMe from './components/ByMe/ByMe';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';
import PrivacyPolicy from './components/privacy/Privacy';

const ReceptionistWrapper=()=> {
  return <>
  <FirstScreenRec/>
  <SecondScreenRec/>
  <ThirdScreenRec/>
  <FourthScreenRec/>
  <SixthScreenRec/>
  <SeventhScreenRec/>
  <EighthScreenRec/>
  <NinthScreenRec/>
  <TenthScreenRec/>
  <EleventhScreenRec/>
  <FifthScreenRec/>
  {/* <ReceptionistHeroSection/>
  <ReceptionistSignals/>
  <ReceptionistSPassion/>
   <ReceptionistAboutMe/>
  <Receptionistbonus/>
  <ReceptionistCourseBenefits/>
  <ReceptionistCourseUpsAndDowns/>
  <ReceptionistCourseWhyNow/>
  <ReceptionistCourseTwoOptions/>
<ReceptionistFAQSection/> */}
 
<FloatingWhatsAppButton/>
    <PrivacyPolicy 
                      ownerName="קרן אקסלרוד - המשרד" 
                      email="Kerenaxelrod@gmail.com" 
                      phone="+972 50-891-9747" 
                      domain="https://hamisrad.co.il/" 
                    />
{/* <ExitIntentPopup/> */}
<ByMe/>
  </>
}

export default ReceptionistWrapper;
